import { defineComponent as _, computed as C, resolveComponent as g, createElementBlock as l, openBlock as s, Fragment as u, renderList as x, createBlock as E, normalizeClass as d, toDisplayString as f, withCtx as S, createTextVNode as b } from "vue";
import { APPS as a } from "./constants.js";
import { setPersistentItem as T, getPersistentItem as v, removePersistentItem as R } from "./utils/storage.js";
const N = {
  class: "stash-context-switcher tw-mx-auto tw-flex tw-w-64 tw-rounded-full tw-border tw-border-white/10 tw-bg-purple-700 tw-p-1.5 tw-text-center",
  "data-test": "stash-context-switcher"
}, B = ["href", "onClick"], h = "-last-session", L = /* @__PURE__ */ _({
  name: "ll-context-switcher",
  __name: "ContextSwitcher",
  props: {
    activeApp: {},
    portalAccess: { default: () => ({
      commercePortal: !1,
      paymentsPortal: !1
    }) },
    limitedAccessUrl: {},
    routeQuery: { default: () => ({}) }
  },
  emits: ["click", "switch"],
  setup(A, { emit: y }) {
    const e = A, p = y, P = C(() => [
      {
        app: a.MARKETPLACE,
        name: e.portalAccess.commercePortal ? "dashboard" : e.limitedAccessUrl,
        hasBaseRoute: e.portalAccess.commercePortal
      },
      {
        app: a.PAYMENTS,
        name: e.portalAccess.paymentsPortal ? "payments" : e.limitedAccessUrl,
        hasBaseRoute: !1
      }
    ]);
    function m(o, n) {
      if (n === e.activeApp)
        return;
      const r = window.location.href;
      let t = o.target.href;
      if (e.portalAccess.paymentsPortal && e.portalAccess.commercePortal) {
        const k = `${n === a.PAYMENTS ? a.MARKETPLACE : a.PAYMENTS}${h}`, w = `${n}${h}`;
        T(k, r, { global: !0 });
        const i = v(w, { global: !0 });
        i && (o.preventDefault(), t = i, window.location.href = i, R(w, { global: !0 }));
      }
      p("click", { from: r, to: t }), p("switch", o, { from: r, to: t });
    }
    return (o, n) => {
      const r = g("router-link");
      return s(), l("div", N, [
        (s(!0), l(u, null, x(P.value, (t) => (s(), l(u, {
          key: t.app
        }, [
          t.hasBaseRoute ? (s(), l("a", {
            key: 0,
            class: d(["tw-w-1/2 tw-cursor-pointer tw-rounded-full tw-py-2.5 tw-font-semibold !tw-capitalize tw-leading-none !tw-no-underline", e.activeApp === t.app ? "tw-text-white tw-bg-royal-500" : "tw-text-ice-500"]),
            href: `/${t.name}`,
            onClick: (c) => m(c, t.app)
          }, f(t.app), 11, B)) : (s(), E(r, {
            key: 1,
            class: d(["tw-w-1/2 tw-cursor-pointer tw-rounded-full tw-py-2.5 tw-font-semibold !tw-capitalize tw-leading-none !tw-no-underline", e.activeApp === t.app ? "tw-text-white tw-bg-royal-500" : "tw-text-ice-500"]),
            to: { name: t.name, query: o.routeQuery },
            "data-test-route": JSON.stringify({ name: t.name, query: o.routeQuery }),
            onClick: (c) => m(c, t.app)
          }, {
            default: S(() => [
              b(f(t.app), 1)
            ]),
            _: 2
          }, 1032, ["class", "to", "data-test-route", "onClick"]))
        ], 64))), 128))
      ]);
    };
  }
});
export {
  L as default
};
//# sourceMappingURL=ContextSwitcher.js.map
